import styled, { keyframes, css } from "styled-components"
import { animated } from "react-spring"
import { darkenColor, getTemperature, alphaColor } from "../../utils/color"

export const ProgressBarWrapper = styled.div<{ width: number | string }>`
  width: ${props => props.width};
  margin: 0;
  position: relative;
`
export const DetailsRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`

export const labelEntrance = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`

export const BarTrack = styled.div`
  position: relative;
  z-index: 1;
  border-radius: 0;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);
  background: rgba(255, 255, 255, 0.2);
  margin: 0.25rem 0 0;
`

// @ts-ignore
export const BarInner = styled(animated.div)<{ color: string }>`
  height: 100%;
  width: 0%;

  background: linear-gradient(
    0deg,
    ${props => darkenColor(props.color)} 0%,
    ${props => props.color} 100%
  );

  box-shadow: 0 0 10px ${props => alphaColor(props.color, 0.4)};
`

export const Label = styled.label`
  font-size: 1rem;
`

export const MarkerWrap = styled.span`
  position: absolute;
`

export const ValueLabel = styled.span<{ animated?: boolean }>`
  text-align: right;

  opacity: ${props => (props.animated ? 0 : 1)};
  animation: ${props =>
    props.animated
      ? css`
          ${labelEntrance} 1s 2s forwards ease
        `
      : "none"};
`

export const IconsWrap = styled.div`
  position: relative;

  svg {
    width: 80%;
    height: 80%;
    margin: 10%;
  }
`
export const IconsPrimary = styled.div<{ color: string }>`
  position: absolute;
  display: flex;
  flex-direction: row;
  path {
    fill: ${props => props.color};
  }
`

export const IconsBg = styled.div`
  position: absolute;
  opacity: 0.08;
  display: flex;
  flex-direction: row;
`

export const TicksWrap = styled.div`
  position: absolute;
  top: 0;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
`
export const Tick = styled.div`
  width: 1px;
  background: rgba(0, 0, 0, 0.2);
`

export const autoColorScale = getTemperature
